import React from 'react';
import {
  SidebarWrapper,
  Title,
  InputWrapper,
  Label,
  StyledInput,
} from './Sidebar.styles';

const Sidebar = ({ variables, handleInput, children }) => {
  return (
    <SidebarWrapper>
      <Title variant="h3">Fill in Details</Title>
      {Object.keys(variables).map((key) => (
        <InputWrapper key={key}>
          <Label>
            {key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ')}
          </Label>
          <StyledInput
            variant="outlined"
            placeholder={`Enter ${key}`}
            value={variables[key]}
            onChange={(e) => handleInput(key, e.target.value)}
            fullWidth
          />
        </InputWrapper>
      ))}
      {children}
    </SidebarWrapper>
  );
};

export default Sidebar;
